import React, { useState } from 'react';
import { isEmpty } from 'lodash';
import { useSelector } from 'react-redux';
import { Box, Typography, List, ListItem, ListItemText, Button } from '@mui/material';
import { PricingItem } from 'common/types';
import { useTranslation } from 'services/localization/useTranslation';

import * as ShopSelectors from 'selectors/ShopSelectors';

import PricingTableRowAdd from './PricingTableRowAdd';
import PricingTableSelectModal from './PricingTableSelectModal';

interface Props {
	onChooseExisting: (pricingTableName: string, pricingTable: PricingItem[]) => void;
	onCreateNew: (pricingTable: PricingItem[]) => void;
	disabled?: boolean;
}

const PricingTableEmpty = (props: Props) => {
	const { onCreateNew, onChooseExisting } = props;
	const { t } = useTranslation();
	const pricingTables = useSelector(ShopSelectors.activeShopPricingTables);
	const [modalOpen, setModalOpen] = useState(false);

	return (
		<Box display="flex" flexDirection="row" alignItems="flex-start" p={2}>
			<List>
				<ListItem>
					<ListItemText
						inset
						primary={t('pricing.usePricingTemplate')}
						secondary={
							<>
								<Typography variant="body2" gutterBottom>
									{t('pricing.usePricingTemplateDescription')}
								</Typography>
								<Box mt={2}></Box>
								<Button
									variant="outlined"
									color="primary"
									disabled={props.disabled || isEmpty(pricingTables)}
									onClick={() => setModalOpen(true)}
								>
									{isEmpty(pricingTables)
										? t('pricing.noSavedTemplates', 'No saved templates')
										: t('pricing.chooseTemplate', 'Choose template')}
								</Button>
								<PricingTableSelectModal
									isOpen={modalOpen}
									onClose={() => setModalOpen(false)}
									onSelect={onChooseExisting}
								/>
							</>
						}
					/>
				</ListItem>
				<ListItem>
					<ListItemText
						inset
						primary={t('pricing.createNewPricingTable', 'Create a new pricing table')}
						secondary={
							<>
								<Typography variant="body2" gutterBottom>
									{t(
										'pricing.createNewPricingTableDescription',
										'Create a new pricing table for this product',
									)}
								</Typography>
								<Box mt={2}></Box>
								<PricingTableRowAdd
									onAdd={(item) => onCreateNew([item])}
									disabled={props.disabled}
								/>
							</>
						}
					/>
				</ListItem>
			</List>
		</Box>
	);
};

export default PricingTableEmpty;
